<template>
  <v-date-picker
    :value="value"
    :formats="{ input: format }"
    :min-date="minDate"
    :max-date="maxDate"
    popover-visibility="focus"
    title-transition="none"
    weeks-transition="none"
    @input="$emit('change', $event)"
  >
    <template slot-scope="{ inputValue, updateValue }">
      <div class="v-date-picker-wrapper">
        <font-awesome-icon
          :icon="inputValue ? 'times' : 'plus'"
          @click="inputValue ? updateValue('') : $refs.dateInput.focus()"
        />
        <input ref="dateInput" :value="inputValue" :placeholder="placeholder" />
        <font-awesome-icon icon="chevron-down" @click="$refs.dateInput.focus()" />
      </div>
    </template>
  </v-date-picker>
</template>

<script>
export default {
  name: 'DatePicker',
  props: {
    value: {
      type: Date,
      default: null
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    placeholder: {
      type: String,
      default: 'Date'
    },
    minDate: {
      type: Date,
      default: null
    },
    maxDate: {
      type: Date,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/colors.scss';
@import '../styles/variables.scss';

.v-date-picker-wrapper {
  border: 1px solid $dark-blue;
  display: flex;
  padding: 5px 3px;
  flex: 1;

  > .fa-plus {
    color: $text-color-dark-3;
    cursor: pointer;
  }

  > .fa-times {
    color: $red;
    cursor: pointer;
  }

  > .fa-chevron-down {
    color: $text-color-dark;
    cursor: pointer;
    margin-left: auto;
  }

  > input {
    font-family: $font-family;
    font-weight: bold;
    color: $text-color-dark;
    border: none;
    font-size: 12px;
    padding: 0px 6px;

    &::placeholder {
      opacity: 1;
    }
  }
}

@media only screen and (min-width: 768px) {
}
</style>
